import { Box, Divider, Typography } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { useIntl } from "react-intl";
import FilesAPI2DModel from "../../models/standard/FilesAPI2DModel";
import FilesAPIProductModel from "../../models/standard/FilesAPIProductModel";
import { immersightBlue } from "../../utils/colors";

const ImsTooltipContainer = styled("div")(() => ({
    backgroundColor: "#fff",
    color: "#333",
    padding: "12px",
    maxWidth: "250px",
    textAlign: "center",
    border: "none !important",
    boxShadow: "none !important",
    outline: "none !important",
    filter: "none !important",
    borderRadius: "0px !important",
}));

// Unified type for both models
type ProductOrModel = FilesAPIProductModel | FilesAPI2DModel;

interface RoomComponentTooltipContainerProps {
  roomComponent: ProductOrModel;
  isTexture?: boolean;
}

const RoomComponentTooltipContainer = ({ roomComponent: product, isTexture = false }: RoomComponentTooltipContainerProps) => {
    const intl = useIntl();

    return (
        <ImsTooltipContainer>
            {/* Product or Model Name */}
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: immersightBlue, textTransform: "uppercase" }}>
                {product.name}
            </Typography>

            {/* Manufacturer (Only for Products) */}
            {"manufacturer" in product && product.manufacturer && (
                <Typography variant="body2" sx={{ fontStyle: "italic", color: "#666" }}>
                    {intl.formatMessage({ id: "ProductGallery.from" })} {product.manufacturer.name}
                </Typography>
            )}

            {/* Description (Only for Products) */}
            {"description" in product && product.description && (
                <Typography variant="body2" sx={{ marginTop: "6px", color: "#333" }}>
                    {product.description}
                </Typography>
            )}

            {/* Dimensions with Divider, only for non-textures */}
            {!isTexture && (
                <>
                    <Divider
                        sx={{
                            my: 1,
                            "&::before, &::after": { borderTop: "1px solid rgba(0, 0, 0, 0.2)", flexGrow: 1 },
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
                            {intl.formatMessage({ id: "ProductGallery.dimensions" })}
                        </Typography>
                    </Divider>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: "24px", marginTop: "6px" }}>
                        <Typography variant="body2">
                            <strong>{intl.formatMessage({ id: "ProductGallery.length" })}</strong> {product.length || "xx"} mm
                        </Typography>
                        <Typography variant="body2">
                            <strong>{intl.formatMessage({ id: "ProductGallery.width" })}</strong> {product.depth || "xx"} mm
                        </Typography>
                    </Box>
                </>
            )}
        </ImsTooltipContainer>
    );
};

export default RoomComponentTooltipContainer;